import { useCallback, useEffect, useRef } from "react";

type UseSenderPendingSendWhileUploadParams = {
  isUploading: boolean;
  /** Invoked when a send was queued during upload and uploads have finished */
  flushSend: () => void;
};

/**
 * When uploads are in progress, coalesce send intent and run once uploads clear.
 * Mirrors Sender pendingSendRef + effect behavior.
 */
export function useSenderPendingSendWhileUpload({
  isUploading,
  flushSend,
}: UseSenderPendingSendWhileUploadParams) {
  const pendingSendRef = useRef(false);

  useEffect(() => {
    if (!isUploading && pendingSendRef.current) {
      pendingSendRef.current = false;
      flushSend();
    }
  }, [isUploading, flushSend]);

  const trySend = useCallback(() => {
    if (isUploading) {
      pendingSendRef.current = true;
      return;
    }
    flushSend();
  }, [isUploading, flushSend]);

  return { trySend };
}
